module.exports = __webpack_public_path__ + "static/media/84.937135f2.png";